import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/prices",
  "use": "navigation/prices-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/prices\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.2 7.403a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm7.6 7.6a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm-6.3-10.8a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0zm6.3 8.9a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6zM1.793 14.21a1 1 0 0 0 1.414 0l11-11a1 1 0 0 0-1.414-1.414l-11 11a1 1 0 0 0 0 1.414z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol